/**
 * Two3 quote-first catalog runtime.
 *
 * This draft theme intentionally uses Shopify products as a browsable solutions
 * catalog, not as a direct ecommerce checkout. Numeric pricing and purchase
 * controls are replaced with quote CTAs in Liquid; this runtime handles the
 * remaining global storefront behavior and contact-form autofill.
 */
(function () {
  'use strict';

  var CONTACT_PATH = '/pages/contact-us';
  var STYLE_ID = 'two3-quote-catalog-styles';

  function injectQuoteCatalogStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '/* Two3 quote-first catalog */',
      '.header__icon--cart,',
      'cart-drawer,',
      'cart-notification,',
      '.quick-add,',
      'quick-add-modal,',
      '.quick-add-modal,',
      'quick-add-bulk,',
      '.shopify-payment-button,',
      '.product-form__quantity,',
      '.quantity__rules,',
      '.quantity__rules-cart,',
      'volume-pricing,',
      '.volume-pricing-note,',
      '.price-per-item,',
      '.installment,',
      '.product__tax,',
      'shopify-payment-terms,',
      'pickup-availability,',
      '.product__pickup-availabilities,',
      'form[action*="/cart/add"] { display: none !important; }',
      'details:has(price-range),',
      '.mobile-facets__details:has(price-range) { display: none !important; }',
      '.two3-quote-price { margin-top: 0.7rem; }',
      '.two3-quote-price .two3-quote-link {',
      '  color: rgba(var(--color-foreground), 0.85);',
      '  font-weight: 600;',
      '  text-decoration: underline;',
      '  text-underline-offset: 0.3rem;',
      '}',
      '.two3-request-quote-button { text-decoration: none; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function fillQuoteRequest() {
    const params = new URLSearchParams(location.search);
    const values = {
      'Requested solution': params.get('quote_for'),
      'Requested product': params.get('quote_product'),
      'Requested configuration': params.get('quote_configuration'),
      'Product page': params.get('quote_path')
    };
    const form = document.querySelector('#two3-inquiry')?.closest('form');
    if (!form) return;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
      if (params.has(key)) values[key] = params.get(key);
    });
    Object.entries(values).forEach(([name, value]) => {
      if (!value || form.querySelector('[name="contact[' + name + ']"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'contact[' + name + ']'; input.value = value.slice(0, 500);
      form.appendChild(input);
    });
    const context = form.querySelector('[data-two3-inquiry-context]');
    if (context && values['Requested product']) {
      context.hidden = false;
      context.querySelector('span').textContent = [values['Requested product'], values['Requested configuration']].filter(Boolean).join(' / ');
    }
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-two3-product]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    const scope = link.closest('product-info') || link.closest('.product');
    if (scope) {
      const options = Array.from(scope.querySelectorAll('variant-selects input:checked, variant-selects select')).map(input => {
        const fieldset = input.closest('fieldset');
        const label = fieldset?.querySelector('legend')?.textContent.trim() || input.name.replace(/^options\[|\]$/g, '');
        return label + ': ' + input.value;
      });
      if (options.length) url.searchParams.set('quote_configuration', options.join('; '));
    }
    const current = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
      if (current.has(key)) url.searchParams.set(key, current.get(key).slice(0, 150));
    });
    link.href = url.pathname + url.search + url.hash;
  }, true);

  function removePriceFilters() {
    document.querySelectorAll('price-range').forEach(function (range) {
      var container = range.closest('details, .mobile-facets__details, .js-filter');
      if (container) container.remove();
    });

    document.querySelectorAll('.js-filter, .mobile-facets__details').forEach(function (filter) {
      var summary = filter.querySelector('summary');
      var label = summary ? summary.textContent.trim().toLowerCase() : '';
      if (label === 'price') filter.remove();
    });

    document.querySelectorAll('facet-remove').forEach(function (pill) {
      var anchor = pill.querySelector('a[href]');
      var href = anchor ? anchor.getAttribute('href') || '' : '';
      var text = (pill.textContent || '').trim().toLowerCase();
      if (href.indexOf('filter.v.price') !== -1 || text.indexOf('price:') === 0) {
        pill.remove();
      }
    });
  }

  function removeSaleBadges() {
    document.querySelectorAll('.card__badge .badge, .price__badge-sale').forEach(function (badge) {
      if ((badge.textContent || '').trim().toLowerCase() === 'sale') badge.remove();
    });
  }


  function cleanupQuoteCatalog() {
    fillQuoteRequest();
    removePriceFilters();
    removeSaleBadges();
  }

  injectQuoteCatalogStyles();

  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    window.location.replace(CONTACT_PATH);
    return;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(CONTACT_PATH);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href === '/cart' || href.indexOf('/cart?') === 0) {
        event.preventDefault();
        window.location.assign(CONTACT_PATH);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupQuoteCatalog, { once: true });
  } else {
    cleanupQuoteCatalog();
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      removePriceFilters();
      removeSaleBadges();
      });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

